import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Link, Text } from '@chakra-ui/react';
import { Alert, Form, Notification } from '@whitbread-eos/atoms';
import { formatDataTestId, useRestMutationRequest } from '@whitbread-eos/utils';
import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import { resetPasswordFormConfig } from './resetPasswordFormConfig';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function ResetPasswordPIVariant(_ref) {
  var _labels$forgottenPass, _labels$forgottenPass2;
  var getFormState = _ref.getFormState,
    defaultValues = _ref.defaultValues,
    defaultErrors = _ref.defaultErrors,
    setIsLoginForm = _ref.setIsLoginForm,
    onClose = _ref.onClose,
    labels = _ref.labels,
    isBookingFlow = _ref.isBookingFlow;
  var baseDataTestId = 'ResetPassword';
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  var _useRestMutationReque = useRestMutationRequest("".concat(publicRuntimeConfig.NEXT_PUBLIC_REST_API, "/auth/hotels/forgot-password?business=false"), 'POST'),
    mutation = _useRestMutationReque.mutation,
    data = _useRestMutationReque.data,
    isError = _useRestMutationReque.isError;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    resetForm = _useState2[0],
    setResetForm = _useState2[1];
  var getEmailRedirectUrl = () => {
    var path = '/gb/en/reset-password.html?token=';
    if (process.env.NODE_ENV === 'development') {
      return "".concat(process.env.NEXT_PUBLIC_POC_URL).concat(path);
    }
    return "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(path);
  };
  useEffect(() => {
    setResetForm(prev => prev + 1);
  }, []);
  var onCancel = () => {
    if (setIsLoginForm) {
      setIsLoginForm(true);
    } else {
      onClose === null || onClose === void 0 || onClose();
    }
  };
  var onSubmit = data => {
    mutation.mutate({
      url: getEmailRedirectUrl(),
      username: data.email
    });
  };
  return _jsx(Flex, _objectSpread(_objectSpread({
    "data-testid": formatDataTestId(baseDataTestId, 'Container'),
    direction: "column"
  }, containerStyles), {}, {
    children: (data === null || data === void 0 ? void 0 : data.success) === true ? _jsxs(Flex, _objectSpread(_objectSpread({}, textContainerStyles), {}, {
      children: [_jsx(Text, _objectSpread(_objectSpread({}, resetPassTitleStyles), {}, {
        children: labels === null || labels === void 0 || (_labels$forgottenPass = labels.forgottenPassword) === null || _labels$forgottenPass === void 0 ? void 0 : _labels$forgottenPass.emailSentHeader
      })), _jsx(Text, _objectSpread(_objectSpread({}, resetPassDescStyles), {}, {
        children: labels === null || labels === void 0 || (_labels$forgottenPass2 = labels.forgottenPassword) === null || _labels$forgottenPass2 === void 0 ? void 0 : _labels$forgottenPass2.emailSentMessage
      })), _jsx(Flex, {
        direction: "row",
        justifyContent: "center",
        children: _jsx(Link, _objectSpread(_objectSpread({}, linkStyles), {}, {
          onClick: onCancel,
          "data-testid": formatDataTestId(baseDataTestId, isBookingFlow ? 'BackToYourDetails' : 'BackToLogin'),
          children: isBookingFlow ? labels.forgottenPassword.backToYourDetails : labels.forgottenPassword.backToLogin
        }))
      })]
    })) : _jsxs(_Fragment, {
      children: [_jsxs(Flex, _objectSpread(_objectSpread({}, textContainerStyles), {}, {
        children: [_jsx(Text, _objectSpread(_objectSpread({}, resetPassTitleStyles), {}, {
          children: labels.forgottenPassword.leisure.formTitle
        })), _jsx(Text, _objectSpread(_objectSpread({}, resetPassDescStyles), {}, {
          children: labels.forgottenPassword.leisure.formLabel
        }))]
      })), isError && _jsx(Flex, _objectSpread(_objectSpread({}, errorContainerStyles), {}, {
        "data-testid": formatDataTestId(baseDataTestId, 'Error'),
        children: _jsx(Notification, {
          description: labels.forgottenPassword.genericError,
          variant: "alert",
          status: "warning",
          svg: _jsx(Alert, {})
        })
      })), _jsx(Form, _objectSpread({}, resetPasswordFormConfig({
        getFormState,
        defaultValues,
        defaultErrors,
        onSubmit,
        baseDataTestId,
        labels,
        resetForm
      }))), _jsx(Flex, {
        direction: "row",
        justifyContent: "center",
        children: _jsx(Link, _objectSpread(_objectSpread({}, linkStyles), {}, {
          onClick: onCancel,
          "data-testid": formatDataTestId(baseDataTestId, 'Cancel'),
          children: labels.forgottenPassword.cancel
        }))
      })]
    })
  }));
}
var containerStyles = {
  margin: {
    mobile: '1.5rem 1rem',
    sm: '1.5rem 2rem',
    md: '1.5rem 6.875rem'
  },
  width: {
    mobile: 'auto',
    xs: 'auto',
    sm: '25rem',
    md: '26rem'
  }
};
var textContainerStyles = {
  alignItems: 'center',
  direction: 'column',
  padding: 0
};
var resetPassTitleStyles = {
  color: 'darkGrey1',
  fontSize: 'md',
  fontWeight: 'semibold',
  marginBottom: 'md'
};
var resetPassDescStyles = {
  align: 'center',
  color: 'darkGrey1',
  fontSize: 'md',
  fontWeight: 'normal',
  marginBottom: '2xl'
};
var linkStyles = {
  color: 'btnSecondaryEnabled',
  textDecoration: 'underline',
  fontSize: 'md'
};
var errorContainerStyles = {
  marginBottom: '2xl'
};